module.exports = __webpack_public_path__ + "img/cd_roof.83df7fc2.jpg";